import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchHabits } from 'Redux/Admin/HabitManager/Habits/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IHabit } from 'Redux/Admin/HabitManager/Habits/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<IHabit> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/habits/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    render: (_, record) => record.type ? "Bad" : "Good",
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Area',
    dataIndex: 'area_name',
    key: 'area_name',
    width: 120,
  },
  {
    title: 'Category',
    dataIndex: 'category_name',
    key: 'category_name',
    width: 120,
  },
  {
    title: 'Subcategory',
    dataIndex: 'subcategory_name',
    key: 'subcategory_name',
    width: 120,
  },
];

const Habits = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const category = params.get('category');
  const subcategory = params.get('subcategory');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchHabits);

  useEffect(() => {
    dispatch(fetchHabits({ category, subcategory, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [category, subcategory, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
    {
      type: 'habit-category-select',
      paramName: 'category',
      placeholder: 'Select category...',
      label: 'Category'
    },
    {
      type: 'habit-subcategory-select',
      paramName: 'subcategory',
      placeholder: 'Select subcategory...',
      label: 'Subcategory'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IHabit>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/habits/new`}
      filters={filterConfigs}
    />
  );
}

export default Habits;
